import React from "react";

const EmailVerification = ({ onClosePopup, email }) => {
  return (
    <div className="email-verification">
      <div className="modal-bg-centered" />
      <div className="modal-centered">
        {/* Header */}
        <div className="head-general with-back">
          <a href="javascript: void(0)" />
          <h4 className="info-title hide-xs">E Mail Verification</h4>
          <a
            href="javascript: void(0)"
            onClick={onClosePopup}
            className="close"
          >
            <icon className="icon icon-close" />
          </a>
        </div>
        {/* Header */}
        <div className="modal-body sticky-buttons">
          <h2 className="visible-xs">E Mail Verification</h2>
          <div className="promo-error white-bg">
            <i className="icon icon-email-verification" />
            <h4>Your email has been confirmed!</h4>
            {(email && <p>Your verified email is {email}</p>) || <noscript />}
          </div>
          <div className="use-buttons email-verification">
            <button className="btn btn-blue" onClick={onClosePopup}>
              Order Now!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
